// extracted by mini-css-extract-plugin
export default {"info_card":"styles_info_card__IrnUp","info_card_detail":"styles_info_card_detail__a3B4a","heading":"styles_heading__+QL68"};